import { SxProps } from '@mui/system';
import { MyTheme } from 'src/theme';

export const pageHeadingStyles: SxProps = {
  paddingBottom: 8,
};

export const tabStyles: SxProps<MyTheme> = {
  flex: '1 1 25%',
  minWidth: '25%',
};

export const tabPanelStyles: SxProps<MyTheme> = {
  borderBottom: '1px solid',
  borderBottomColor: ({ palette }) => palette.divider,
};

export const tabContentStyles: SxProps<MyTheme> = {
  paddingTop: 5,
};
